import script from "./UserReactionsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./UserReactionsModal.vue?vue&type=script&setup=true&lang=js"

import "./UserReactionsModal.vue?vue&type=style&index=0&id=4ad815d6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ad815d6"]])

export default __exports__